module.exports = __webpack_public_path__ + "assets/add-browser.ce5b5ec7.svg";